var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-container"},[_c('new-ui-notifications'),_c('div',{staticClass:"login-page registration"},[_c('div',{staticClass:"login-page__modal col-12 col-md-6 col-xl-4"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }